/**
 * form関連
 */

export default class Form {
	constructor() {
		this.input = document.querySelectorAll('.input');
		this.input_select = document.querySelectorAll('.input--select');
		this.input_body = document.querySelectorAll('.input__body');
		this.select_item = document.querySelectorAll('.selectbox-item');

		this.addListeners();
	}

	/**
	 * イベント登録
	 */
	addListeners() {
		// bodyイベント追加
		document.body.addEventListener('click', this.selectBlur, false);

		// inputイベント追加
		for (let i = 0, l = this.input.length; i < l; i++) {
			this.input[i].addEventListener('click', this.inputOnFocus.bind(this), false);
		}

		// input_bodyイベント追加
		for (let i = 0, l = this.input_body.length; i < l; i++) {
			let current = this.input_body[i];

			current.addEventListener('focus', this.inputOnFocus.bind(this), false);
			current.addEventListener('blur', this.inputOnBlur, false);
			current.addEventListener('keydown', this.inputOnKeyDown, false);

			// 初期値チェック
			if (current.value) {
				let front = current.parentNode.querySelector('.input__front');

				// selectの初期値設定
				if (front) {
					let select_item = current.parentNode.querySelectorAll('.selectbox-item');

					for (let i = 0, l = select_item.length; i < l; i++) {
						let s = select_item[i];
						let d_val = s.getAttribute('data-value');

						s.classList.remove('selectbox-item--current');

						if (d_val === current.value) {
							s.classList.add('selectbox-item--current');
							front.textContent = s.textContent;
						}
					}
				}

				this.input[i].classList.add('input--selected');
			}
		}

		// input--selectのイベント伝播止める
		for (let i = 0, l = this.input_select.length; i < l; i++) {
			this.input_select[i].addEventListener('click', (e) => e.stopPropagation(), false);
		}

		// select選択イベント追加
		for (let i = 0, l = this.select_item.length; i < l; i++) {
			this.select_item[i].addEventListener('click', this.selectBoxClick.bind(this), false);
		}
	}

	/**
	 * フォーカス処理
	 */
	inputOnFocus(e) {
		const _this = e.type === 'focus' ? e.currentTarget.parentNode : e.currentTarget;
		const body = e.type === 'focus' ? _this : _this.querySelector('.input__body');

		if (_this.classList.contains('input--disabled')) return;

		if (!_this.classList.contains('input--select')) {
			for (let i = 0, l = this.input_select.length; i < l; i++) {
				this.input_select[i].classList.remove('input--focus');
			}
		}

		_this.classList.add('input--focus');
		body.focus();
	}

	/**
	 * ブラー処理
	 */
	inputOnBlur() {
		const input = this.parentNode;
		const val = this.value;

		// selectはスルー
		if (input.classList.contains('input--select')) return;

		if (val) return;

		input.classList.remove('input--focus', 'input--selected');
	}

	/**
	 * selectの疑似ブラー処理
	 */
	selectBlur() {
		const input = document.querySelectorAll('.input--select');

		for (let i = 0, l = input.length; i < l; i++) {
			input[i].classList.remove('input--focus');
		}
	}

	/**
	 * キーボード操作処理
	 */
	inputOnKeyDown(e) {
		if (this.parentNode.classList.contains('input--select')) e.preventDefault();
	}

	/**
	 * select選択処理
	 */
	selectBoxClick(e) {
		e.stopPropagation();

		const _this = e.currentTarget;
		const list = _this.parentNode;
		const item = list.querySelectorAll('.selectbox-item');
		const index = Array.prototype.indexOf.call(document.querySelectorAll('.selectbox-list'), list);
		const text = _this.textContent;
		const val = _this.getAttribute('data-value');
		const input = this.input_select[index];
		const input_body = input.querySelector('.input__body');
		const front = input.querySelector('.input__front');

		for (let i = 0, l = item.length; i < l; i++) {
			item[i].classList.remove('selectbox-item--current');
		}
		_this.classList.add('selectbox-item--current');

		front.textContent = text;
		input_body.value = val;
		input.classList.remove('input--focus');
		input.classList.add('input--selected');
	}
}



// WEBPACK FOOTER //
// ./src/js/module/Form.js